import { cn } from "@/lib/cn";
import { forwardRef, type ComponentPropsWithoutRef } from "react";

const SEAMS = [
  "[&>*:first-child]:min-w-0 [&>*:first-child]:flex-1",
  "[&>*:first-child:not(:only-child)]:rounded-r-none [&>*:first-child:not(:only-child)]:border-r-0",
  "[&>*:last-child:not(:only-child)]:h-auto [&>*:last-child:not(:only-child)]:shrink-0 [&>*:last-child:not(:only-child)]:rounded-l-none",
];

export type InputGroupProps = ComponentPropsWithoutRef<"div">;

/**
 * Glues a field (first child, usually TextField) to an optional trailing action (last child, usually Button) so they
 * read as one control; seams apply only while the action is present, so it can mount and unmount without remounting the field.
 */
export const InputGroup = forwardRef<HTMLDivElement, InputGroupProps>(function InputGroup(
  { className, children, ...rest },
  ref,
) {
  return (
    <div {...rest} ref={ref} className={cn("flex w-full items-stretch", SEAMS, className)}>
      {children}
    </div>
  );
});
